import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  header: {
    marginBottom: 0
  },
  boatItem: {
    backgroundColor: theme.colorPalette.green_80,
    padding: theme.spacing(2, 4),
    borderBottom: `0.5px solid ${theme.colorPalette.beige_50_op_75}`,
    width: '100%',
    '&:first-of-type': {
      borderTopLeftRadius: theme.sizes.roundCorners,
      borderTopRightRadius: theme.sizes.roundCorners
    },
    '&:last-of-type': {
      borderBottomLeftRadius: theme.sizes.roundCorners,
      borderBottomRightRadius: theme.sizes.roundCorners,
      borderBottom: 'none'
    }
  },
  boatContent: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  boatTitle: {
    fontSize: 14,
    fontWeight: 400,
    margin: theme.spacing(0, 0, 1),
    color: theme.colorPalette.beige_50
  },
  boatLength: {
    fontSize: 10,
    fontWeight: 600,
    margin: 0,
    color: theme.colorPalette.beige_50,
    textTransform: 'uppercase'
  },
  deleteButton: {
    color: theme.colorPalette.orange_75
  },
  addFormContainer: {
    width: '100%',
    margin: theme.spacing(2, 0),
    border: `2px solid ${theme.colorPalette.green_80}`,
    borderRadius: theme.sizes.roundCorners,
    padding: theme.spacing(4, 8)
  },
  addRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    width: '100%'
  },
  inputColumn: {
    flex: 1,
    minWidth: 0
  },
  addButton: {
    whiteSpace: 'nowrap',
    flexShrink: 0,
    fontSize: 16,
    padding: theme.spacing(1.5, 4),
    marginTop: 16
  },
  hint: {
    fontSize: 10,
    lineHeight: '12px',
    marginTop: -10
  }
});

export default makeStyles(styles);
